<template>
  <div>

    <b-container fluid>
      <b-row>
        <b-col>
          <h2>{{ title }}</h2>
        </b-col>
      </b-row>

      <b-row align-h="between">
        <b-col lg="5">
          <b-form-group
            label-align="left"
            label-for="filterInput"
            label="Pesquisar operação:"
          >
            <b-input-group>
              <b-form-input
                @input="updateForm('name', $event)" 
                :value="filters.name"
                type="search"
                id="filterInput"
                size="sm"
              ></b-form-input>
              <b-input-group-append>
                <b-button size="sm" :disabled="!filters.name" @click="filters.name = ''">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="3">
          <label for="filter-name">Quantidade:</label>
          <b-form-input id="filter-name" size="sm" type="number" @input="updateForm('limit', $event)" :value="filters.limit">
          </b-form-input>          
        </b-col>        

        <b-col lg="4">
          <b-form-group label-align="left" label="Mostrando:">
            <b-form-radio-group buttons :options="statusOptions" v-model="filters.status" @change="updateForm('status', $event)" class="mybtn">
            </b-form-radio-group>
          </b-form-group>
        </b-col>

      </b-row>

      <b-row>
        <b-col>
          <b-button class="mr-1 mb-3" v-b-modal.filter-date>Filtrar por Data</b-button>
          <b-button v-if="type === 'evento'" class="mr-3 mb-3" variant="secondary" @click="filterNextTwoMonths">Próximos 2 meses</b-button>
          <b-button class="mr-1 mb-3" variant="info" @click="reset">Limpar filtros</b-button>
          <b-button class="mr-1 mb-3" variant="info" @click="filter">Filtrar</b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" v-if="hasFilters" class="mt-2 mb-4">
          <b-card-group>
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>

        <b-col cols="12" class="mt-0 mb-1">
          <p class="m-0">{{ stats }}</p>
        </b-col>

        <b-col cols="12" class="mt-2 mb-3" style="overflow-x: auto;">

          <b-table striped hover show-empty
            :items="events"
            :fields="fields"
            primary-key="id"
            empty-filtered-text="Nenhuma operação encontrada"
            empty-text="Nenhuma operação encontrada"
            ref="table"
            :tbody-tr-class="rowClass"
          >

            <template v-slot:cell(event_type)="data">
              <b-badge :class="data.item.type === 'evento' ? 'blue-1' : 'blue-2'">
                {{ data.item.type | capitalize }}
              </b-badge>
            </template>

            <template v-slot:head(printed)="">
              <div>
                Imp
                <span v-b-tooltip.hover title="Ingressos Impressos">
                  <icon name="info-circle" scale="0.8"></icon>
                </span>
              </div>
            </template>

            <template v-slot:cell(printed)="data">
              <span class="text-success">{{ data.item.tickets.printed | number }}</span>
            </template>

            <template v-slot:head(digital)="">
              <div>
                Dig
                <span v-b-tooltip.hover title="Ingressos Digitais">
                  <icon name="info-circle" scale="0.8"></icon>
                </span>
              </div>
            </template>

            <template v-slot:cell(digital)="data">
              <span class="text-success">{{ data.item.tickets.digital | number }}</span>
            </template>

            <template v-slot:cell(tickets_valid)="data">
              <div>{{ (data.item.tickets.printed + data.item.tickets.digital) | number }}</div>
            </template>

            <template v-slot:head(canceled)="">
              <div>
                Can
                <span v-b-tooltip.hover title="Ingressos Cancelados">
                  <icon name="info-circle" scale="0.8"></icon>
                </span>
              </div>
            </template>

            <template v-slot:cell(canceled)="data">
              <span class="text-danger">{{ data.item.cancel_amount | number }}</span>
            </template>

            <template v-slot:cell(actions)="data">
              <div>
                <b-button :id="`actions-btn-${data.item.id}`" variant="secondary" size="sm" class="mr-1">
                  <icon name="ellipsis-v" scale="1" class="mt-2 mb-0 ml-2"></icon>
                </b-button>
                <b-popover
                  :target="`actions-btn-${data.item.id}`"
                  triggers="click blur"
                  placement="left"
                  boundary="window"
                  custom-class="event-actions-popover"
                >
                  <div class="event-actions-menu">
                    <a class="event-actions-item" @click="updateEventV2(data.item.id); $root.$emit('bv::hide::popover')">
                      <icon name="edit" scale="1" class="mr-2"></icon>Editar operação
                    </a>
                    <a class="event-actions-item" @click="openCoverSender(data.item.id); $root.$emit('bv::hide::popover')">
                      <icon name="image" scale="1" class="mr-2"></icon>Enviar capa
                    </a>
                    <a class="event-actions-item" @click="openCloneModal(data.item.id, data.item.name); $root.$emit('bv::hide::popover')">
                      <icon name="clone" scale="1" class="mr-2"></icon>Clonar operação
                    </a>
                    <hr class="my-1">
                    <a v-if="type === 'evento'" class="event-actions-item" @click="listTickets(data.item.id, data.item.name); $root.$emit('bv::hide::popover')">
                      <icon name="ticket-alt" scale="1" class="mr-2"></icon>Listar {{ gui.tickets.toLowerCase() }}
                    </a>
                    <a class="event-actions-item" @click="listDealers(data.item.id, data.item.name); $root.$emit('bv::hide::popover')">
                      <icon name="store" scale="1" class="mr-2"></icon>Configurações de {{ gui.dealersLC }}
                    </a>
                    <a class="event-actions-item" @click="rateApp(data.item.id); $root.$emit('bv::hide::popover')">
                      <icon name="cash-register" scale="1" class="mr-2"></icon>Tarifa da maquininha
                    </a>
                    <a class="event-actions-item" @click="storeConfig(data.item.id); $root.$emit('bv::hide::popover')">
                      <icon name="store" scale="1" class="mr-2"></icon>Configurações da loja
                    </a>
                    <a class="event-actions-item" @click="eventConfig(data.item.id, data.item.name); $root.$emit('bv::hide::popover')">
                      <icon name="cog" scale="1" class="mr-2"></icon>Configurações avançadas
                    </a>
                    <hr class="my-1">
                    <a class="event-actions-item text-danger" @click="ticketsCancel(data.item.id); $root.$emit('bv::hide::popover')">
                      <icon name="ticket-alt" scale="1" class="mr-2"></icon>Cancelar {{ gui.tickets.toLowerCase() }}
                    </a>
                  </div>
                </b-popover>
              </div>
            </template>

            <template v-slot:cell(organizer_token)="data">
              <div>
                <toggle-button
                  :value="data.item.token !== null"
                  :sync="true" :width="45" :height="25"
                  :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                  @change="switchOrganizerToken(data.item.id)"
                />
              </div>
            </template>

            <template v-slot:cell(online_shop)="data">
              <div>
                <store-status :virtual_store="data.item.virtual_store" :hidden_store="data.item.hidden_store" />
              </div>
            </template>

            <template v-slot:cell(access)="data">
              <div>
                <a v-if="data.item.token" @click="link(data.item.token, data.item.type, data.item.id)" class="text-primary access-link" style="cursor: pointer">
                  <icon name="eye" scale="1"></icon> Acessar
                </a>
                <span v-else class="text-muted">
                  <icon name="eye-slash" scale="1"></icon> Acessar
                </span>
              </div>
            </template>

          </b-table>

        </b-col>


      </b-row>
    </b-container>

    <modal v-if="showModal" ref="modal">
      <router-view name="content"/>
    </modal>

    <clone-event-modal
      :visible="showCloneModal"
      :event-name="cloneEventName"
      :event-id="cloneEventId"
      @close="closeCloneModal"
      @clone="handleClone"
    />

    <b-modal id="filter-date"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Data"
      @ok="filter"
      :ok-disabled="filters.date.start === '' || filters.date.end === ''"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Para filtrar um <span class="font-weight-bold">intervalo de datas</span>, selecione dois dias. Para filtrar um <span class="font-weight-bold">dia específico</span>, clique duas vezes nele. Após isso clique em <span class="font-weight-bold">Filtrar</span>.</p>
      
      <div class="text-center">
        <calendar 
          @input="updateForm('date', $event)"
          :value="filters.date"
          :max-date="maxDate"
        >
        </calendar>
      </div>
    </b-modal>

  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'
import Modal from '@/components/Modal'
import StoreStatus from '@/components/StoreStatus'
import CloneEventModal from '@/components/CloneEventModal'
import Calendar from '@/components/Calendar'
import FilterStore from '@/filterStore'
import Gui from '@/gui'

export default {
  name: 'EventList',
  components: {
    ToggleButton,
    Modal,
    StoreStatus,
    CloneEventModal,
    Calendar
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['evento', 'ficha'].includes(value)
    }
  },
  data () {
    return {
      gui: new Gui(this.type),
      showModal: this.$route.meta.showModal,
      sortBy: 'date',
      sortDesc: true,
      fields: [
        { key: 'event_type', label: 'Tipo', class: ['text-center', 'align-middle'] },
        { key: 'name', label: 'Operação', class: ['align-middle'], thStyle: { minWidth: '250px' }, tdStyle: { minWidth: '250px' }  },
        { key: 'printed', class: ['text-center', 'text-nowrap', 'align-middle'] },
        { key: 'digital', class: ['text-center', 'text-nowrap', 'align-middle'] },
        { key: 'tickets_valid', label: 'Total', class: ['text-center', 'align-middle'] },
        { key: 'canceled', class: ['text-center', 'text-nowrap', 'align-middle'] },
        { key: 'date', label: 'Data', formatter: this.$options.filters.date, class: ['text-center', 'align-middle', 'text-nowrap'] },
        { key: 'online_shop', label: 'Loja', class: ['text-center', 'align-middle'] },
        { key: 'actions', label: 'Ações', class: ['text-nowrap', 'text-center', 'align-middle'] },
        { key: 'organizer_token', label: 'Ativo?', class: ['text-center', 'align-middle'] },
        { key: 'access', label: 'Acessar', class: ['text-center', 'align-middle'] }
      ],
      show: 'next',
      modal: {
        title: '',
        link: ''
      },
      selectedEventId: null,
      events: [],
      appliedFilters: [],
      showCloneModal: false,
      cloneEventId: null,
      cloneEventName: '',
      filters: {
        limit: 10,
        type: this.type,
        status: '',
        name: '',
        date: {
          start: '',
          end: ''
        }
      },      
      filterStore: '',
      statusOptions: [
        { text: 'Todas', value: 'active,inactive' },
        { text: 'Ativas', value: 'active' },
        { text: 'Inativas', value: 'inactive' },
      ]
    }
  },
  async created () {
    const userLogin = this.$session.get('login')
    this.filterStore = new FilterStore(userLogin, this.$route.path)
    
    if (this.type === 'evento') {
      let today = new Date()
      let futureDate = new Date(today)
      futureDate.setDate(today.getDate() + 60)
      
      this.filters.date.start = this.$moment(today.setHours(0, 0, 0)).format('DD/MM/YYYY HH:mm')
      this.filters.date.end = this.$moment(futureDate.setHours(23, 59, 59)).format('DD/MM/YYYY HH:mm')
    }
    
    this.filters = this.filterStore.merge(this.filters)
  },  
  async mounted () {
    const sessionKey = `selectedEventId_${this.type}`
    this.selectedEventId = this.$session.get(sessionKey)
    await this.filter()
  },
  watch: {
    '$route.meta' ({showModal}) {
      this.showModal = showModal
    },
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value) 
    },    
    rowClass (item, type) {
      if (!item || type !== 'row') return
      if (item.id === this.selectedEventId) return 'table-warning'
    },
    setSelectedEvent (eventId) {
      this.selectedEventId = eventId
      const sessionKey = `selectedEventId_${this.type}`
      this.$session.set(sessionKey, eventId)
    },
    openCoverSender (eventId) {
      this.setSelectedEvent(eventId)
      this.$router.push({name: 'AdminEventCover', params: { id: eventId }})
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }      

      filters.push('type=' + this.filters.type)

      // Se tem filtro de data e é evento, ordena por data
      if (this.type === 'evento' && (this.filters.date.start !== '' || this.filters.date.end !== '')) {
        filters.push('sort=date')
        filters.push('order=asc')

        this.appliedFilters.push({
          filter: 'Ordenação',
          values: 'Data do evento (da mais próxima para a mais distante)'
        })
      } else {
        // Caso contrário, ordena por id desc (para ambos os tipos)
        filters.push('sort=id')
        filters.push('order=desc')

        this.appliedFilters.push({
          filter: 'Ordenação',
          values: 'Data de cadastro (da mais recente para a mais antiga)'
        })
      }

      if (this.filters.status.length > 0) {
        filters.push('status=' + this.filters.status)
      }      

      if (this.filters.name !== '') {
        filters.push('name=' + this.filters.name)

        let af = {
          filter: 'Nome',
          values: this.filters.name
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.date.start !== '' && this.filters.date.end !== '') {
        let start = this.$moment(this.filters.date.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        let end = this.$moment(this.filters.date.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        
        filters.push('start_date=' + start + ':00')
        filters.push('end_date=' + end + ':59')

        let startMoment = this.$moment(this.filters.date.start, 'DD/MM/YYYY HH:mm')
        let endMoment = this.$moment(this.filters.date.end, 'DD/MM/YYYY HH:mm')
        let now = this.$moment()
        let daysDiff = endMoment.diff(startMoment, 'days')
        let startDaysFromNow = startMoment.diff(now.startOf('day'), 'days')
        let endDaysFromNow = endMoment.diff(now.startOf('day'), 'days')

        let friendlyText = ''
        
        // Verificar se é um período futuro começando de hoje
        if (startDaysFromNow === 0 && endDaysFromNow >= 0) {
          if (daysDiff === 0) {
            friendlyText = 'Operações de hoje'
          } else if (daysDiff === 1) {
            friendlyText = 'Operações de hoje e amanhã'
          } else if (daysDiff === 7) {
            friendlyText = 'Operações da próxima semana'
          } else if (daysDiff === 14) {
            friendlyText = 'Operações das próximas 2 semanas'
          } else if (daysDiff === 30) {
            friendlyText = 'Operações do próximo mês'
          } else if (daysDiff === 60) {
            friendlyText = 'Operações dos próximos 2 meses'
          } else if (daysDiff === 90) {
            friendlyText = 'Operações dos próximos 3 meses'
          } else if (daysDiff < 7) {
            friendlyText = `Operações dos próximos ${daysDiff} dias`
          } else if (daysDiff < 30) {
            let weeks = Math.round(daysDiff / 7)
            friendlyText = `Operações das próximas ${weeks} semanas`
          } else if (daysDiff < 365) {
            let months = Math.round(daysDiff / 30)
            friendlyText = `Operações dos próximos ${months} meses`
          } else {
            friendlyText = 'De ' + this.filters.date.start + ' até ' + this.filters.date.end
          }
        }
        // Verificar se é um período passado terminando hoje
        else if (endDaysFromNow === 0 && startDaysFromNow <= 0) {
          let absDaysDiff = Math.abs(daysDiff)
          if (absDaysDiff === 0) {
            friendlyText = 'Operações de hoje'
          } else if (absDaysDiff === 7) {
            friendlyText = 'Operações da última semana'
          } else if (absDaysDiff === 14) {
            friendlyText = 'Operações das últimas 2 semanas'
          } else if (absDaysDiff === 30) {
            friendlyText = 'Operações do último mês'
          } else if (absDaysDiff === 60) {
            friendlyText = 'Operações dos últimos 2 meses'
          } else if (absDaysDiff === 90) {
            friendlyText = 'Operações dos últimos 3 meses'
          } else if (absDaysDiff < 7) {
            friendlyText = `Operações dos últimos ${absDaysDiff} dias`
          } else if (absDaysDiff < 30) {
            let weeks = Math.round(absDaysDiff / 7)
            friendlyText = `Operações das últimas ${weeks} semanas`
          } else if (absDaysDiff < 365) {
            let months = Math.round(absDaysDiff / 30)
            friendlyText = `Operações dos últimos ${months} meses`
          } else {
            friendlyText = 'De ' + this.filters.date.start + ' até ' + this.filters.date.end
          }
        }
        // Período customizado
        else {
          friendlyText = 'De ' + this.filters.date.start + ' até ' + this.filters.date.end
        }

        let af = {
          filter: 'Período',
          values: friendlyText
        }

        this.appliedFilters.push(af)
      } else if (this.filters.date.start !== '') {
        let start = this.$moment(this.filters.date.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('start_date=' + start + ':00')

        let af = {
          filter: 'Data',
          values: 'A partir de ' + this.filters.date.start
        }

        this.appliedFilters.push(af)
      } else if (this.filters.date.end !== '') {
        let end = this.$moment(this.filters.date.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('end_date=' + end + ':59')

        let af = {
          filter: 'Data',
          values: 'Até ' + this.filters.date.end
        }

        this.appliedFilters.push(af)
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }
      await this.getEvents(filters)      
    },
    async reset () {
      this.filters.limit = 10
      this.filters.type = this.type
      this.filters.status = 'active'
      this.filters.name = ''
      this.filters.date.start = ''
      this.filters.date.end = ''

      this.filterStore.clear()
      // Persiste datas vazias para que o reload não reaplique o padrão "próximos 2 meses"
      this.filterStore.save('date', { start: '', end: '' })
      await this.filter()
    },
    async filterNextTwoMonths () {
      let today = new Date()
      let futureDate = new Date(today)
      futureDate.setDate(today.getDate() + 60)

      this.filters.date.start = this.$moment(today.setHours(0, 0, 0)).format('DD/MM/YYYY HH:mm')
      this.filters.date.end = this.$moment(futureDate.setHours(23, 59, 59)).format('DD/MM/YYYY HH:mm')
      this.updateForm('date', this.filters.date)

      await this.filter()
    },    
    async getEvents (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/events'

      if (filters !== '' && filters !== undefined) {
        url = url + '?' + filters
      }

      try {
        let resp = await this.$http.get(url)
        this.events = resp.body
        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    link (token, type, eventId) {
      this.setSelectedEvent(eventId)
      this.$session.set('type', type)
      const backRoute = this.type === 'evento' ? 'Events' : 'Fichas'
      this.$session.set('organizerBackRoute', backRoute)
      this.$router.push({
        name: 'OrganizerOverview',
        params: {organizer: token},
      })
      window.scrollTo(0,0)
    },
    updateEvent (eventId) {
      this.setSelectedEvent(eventId)
      this.$router.push({ name: 'UpdateEvent', params: { id: eventId } })
    },
    updateEventV2 (eventId) {
      this.setSelectedEvent(eventId)
      this.$router.push({ name: 'UpdateEventV2', params: { id: eventId } })
    },
    rateApp (eventId) {
      this.setSelectedEvent(eventId)
      this.$router.push({ name: 'AdminEventRate', params: { id: eventId } })
    },
    storeConfig (eventId) {
      this.setSelectedEvent(eventId)
      this.$router.push({ name: 'AdminStoreConfig', params: { id: eventId } })
    },
    eventConfig (eventId, eventName) {
      this.setSelectedEvent(eventId)
      this.$session.set('AdminConfigContext', eventName)
      this.$router.push({ name: 'AdminConfig', params: { id: eventId } })
    },
    ticketsCancel (eventId) {
      this.setSelectedEvent(eventId)
      this.$router.push({ name: 'AdminTicketsCancel', params: { id: eventId } })
    },
    listTickets (eventId, eventName) {
      this.setSelectedEvent(eventId)
      this.$session.set('AdminListTicketsContext', eventName)
      this.$router.push({ name: 'AdminListTickets', params: { id: eventId } })
    },
    listDealers (eventId, eventName) {
      this.setSelectedEvent(eventId)
      this.$session.set('AdminListDealersContext', eventName)
      this.$router.push({ name: 'AdminListDealers', params: { id: eventId } })
    },
    openCloneModal (eventId, eventName) {
      this.cloneEventId = eventId
      this.cloneEventName = eventName
      this.showCloneModal = true
    },
    closeCloneModal () {
      this.showCloneModal = false
      this.cloneEventId = null
      this.cloneEventName = ''
    },
    async handleClone (data) {
      const url = process.env.VUE_APP_URL_APP + `/b/events/${data.id}/clone`
      
      try {
        const response = await this.$http.post(url, { name: data.name })
        this.$bvToast.toast('Operação clonada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
        await this.filter()
        if (response.body?.id) {
          this.setSelectedEvent(response.body.id)
        }
      } catch (e) {
        console.error(e)
        const errorMessage = e.body?.message || 'Erro ao clonar operação'
        this.$bvToast.toast(errorMessage, {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    async switchOrganizerToken (eventId) {
      let table = this.$refs.table.localItems
      let i = this.$_.findIndex(table, e => e.id === eventId)
      let state = table[i].token
      let url = process.env.VUE_APP_URL_APP + `/b/events/${eventId}/tokens`

      try {
        if (state === null) {
          let res = await this.$http.post(url, {})
          let j = this.$_.findIndex(table, o => o.id === eventId)
          table[j].token = res.body.token
        } else {
          await this.$http.delete(url)
          let j = this.$_.findIndex(table, o => o.id === eventId)
          table[j].token = null
        }
      } catch (e) {
        console.error(e)
      }
      return true
    }
  },
  computed: {
    title () {
      return this.type === 'evento' ? 'Eventos' : 'Fichas'
    },
    stats () {
      let qty = this.events.length

      if (qty === 1) {
        return `Exibindo 1 operação`
      } else if (qty > 1) {
        return `Exibindo ${qty} operações`
      }
      return ''
    },
    maxDate () {
      let today = new Date()
      return new Date(today.setFullYear(today.getFullYear() + 2))
    },
    hasFilters () {
      return this.appliedFilters.length !== 0
    }
  }
}
</script>

<style>
.event-actions-popover .popover-body {
  padding: 0.25rem 0;
}
.event-actions-menu {
  display: flex;
  flex-direction: column;
  min-width: 200px;
}
.event-actions-item {
  display: block;
  padding: 0.4rem 1rem;
  cursor: pointer;
  color: #212529;
  text-decoration: none;
  white-space: nowrap;
}
.event-actions-item:hover {
  background-color: #f8f9fa;
  color: #212529;
  text-decoration: none;
}
.event-actions-item.text-danger:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}
.event-actions-popover .popover-body hr {
  margin: 0.25rem 0;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}
</style>

<style scoped>
.access-link {
  text-decoration: none;
}

.access-link:hover {
  text-decoration: none;
}

.blue-1 {
  background-color: #1c4c6c;
}

.blue-2 {
  background-color: #63abcb;
}

.btn-secondary:not(:disabled):not(.disabled).active {
  background: rgb(167, 166, 166)
}
 
.btn-secondary:not(:disabled):not(.disabled).active.mybtn {
  background: #1c4c6c
}
</style>
